import { openRamsRecordModal } from '../../../State/ramsRecordModal'

export default (ramsRecordId) => async (dispatch) => {

  dispatch(openRamsRecordModal({ ramsRecordId }))

}